import * as React from 'react';
import cx from 'classnames';
import { DateTimePicker as ReactDateTimePicker } from 'lib/ReactWidgets';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'reac... Remove this comment to see the full error message
import { datePopups as popups } from 'react-widgets/lib/util/constants';

import { MouseEventHandler } from 'types/typescript/eventHandlers';
import withDateTimePickerPosition from 'components/lib/withDateTimePickerPosition';

import './styles/DatePickerInput.scss';

/**
 * ## Allows the user to pick a date using a calendar UI.
 * ### This component wraps a [React Widget](https://jquense.github.io/react-widgets/docs/#/datetime-picker).
 *
 *
 * ```example
 * <DatePickerInput />
 * ```
 */

type Props = {
  /** Native properties */
  autofocus?: boolean;
  disabled?: boolean;
  placeholder?: string;
  value?: Date;
  /** Non-native properties */
  className?: string;
  full?: boolean;
  max?: Date; // latest date
  min?: Date; // earliest date
  'data-test'?: string;
  focused?: boolean;
  opened?: boolean;
  error?: boolean;
  onBlur?: () => void;
  onChange?: (date?: Date, dateStr?: string) => void;
  onFocus?: () => void;
  onPickerClick?: MouseEventHandler;
  closePopup?: (event: React.KeyboardEvent<any>) => void;
  onClick?: () => void;
  // TODO: format does not follow any standard date formatting conventions.
  // for now, refer to lib/ReactWidgets for our custom formatting logic.
  format?: string;
};

class DatePickerInput extends React.Component<Props> {
  handleClick: MouseEventHandler = (event) => {
    const { disabled, onClick, onPickerClick } = this.props;

    if (!disabled && onPickerClick) {
      onPickerClick(event);
    }

    if (onClick) {
      onClick();
    }
  };

  render() {
    const {
      className,
      closePopup,
      disabled,
      error,
      focused,
      full,
      max,
      min,
      onBlur,
      onChange,
      onFocus,
      opened,
      placeholder,
      value,
      format = 'M/d/yyyy',
    } = this.props;
    const open = opened ? popups.CALENDAR : false;
    const active = focused || opened;

    const parse = (val: string) => {
      const date = new Date(val);
      return date instanceof Date && !isNaN(date.valueOf()) ? date : new Date();
    };

    const calendarProps = {
      // ReactDateTimePicker also takes props from the Calendar component from
      // react-widgets but the typescript declarations don't recognize them
      dayFormat: (date: Date) => ['S', 'M', 'T', 'W', 'T', 'F', 'S'][date.getDay()],
    };

    return (
      <div
        className={cx(
          'DatePickerInput',
          {
            'DatePickerInput--disabled': disabled,
            'DatePickerInput--error': error,
            'DatePickerInput--focused': active,
            'DatePickerInput--full': full,
          },
          className
        )}
        onClick={this.handleClick}
      >
        <ReactDateTimePicker
          {...calendarProps}
          duration={0}
          disabled={disabled}
          finalView="month"
          format={format}
          max={max}
          min={min}
          open={open}
          parse={parse}
          placeholder={placeholder}
          ref="picker"
          value={value}
          onBlur={onBlur}
          onChange={onChange}
          onFocus={onFocus}
          onKeyDown={closePopup}
          onToggle={() => {}}
          data-test={this.props['data-test']}
        />
      </div>
    );
  }
}

export default withDateTimePickerPosition(DatePickerInput);
